import { colors2, transition } from "oolib";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";
import styled, { css } from "styled-components";

const widgetContentPadding = 1.6
const containerRadius = 1.2
export const actionButtonSize = 2.4

export const StyledHeader = styled.button`
  width: 100%;
  border:none;
  text-align: left;
  background: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  padding: 1.2rem 1.2rem 1.2rem 1.6rem;

`;


export const StyledWidgetContainer = styled.div`
  background: ${colors2.white};
  border-radius: ${containerRadius}rem;

  ${({ isExpanded }) => isExpanded && css`
    display: flex;
    flex-direction: column;
  `}

  border: ${props => props.isEditing ? `1px solid ${colors2.grey80}` : `1px solid ${colors2.grey10}`};
  box-shadow: ${props => props.isEditing ? `0 4px 10px 0 rgba(0, 0, 0, 0.12)` : `unset`};
  
  #widget-actions-${props => props.widgetId},
  #widget-download-${props => props.widgetId},
  #widget-switch-${props => props.widgetId} {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  }

  ${({ isEditing }) => isEditing ? css`
      #widget-actions-${props => props.widgetId} {
        opacity: 1;
        visibility: visible;
      }
  ` : css``}

  &:hover #widget-actions-${props => props.widgetId},
  &:hover #widget-download-${props => props.widgetId},
  &:hover #widget-switch-${props => props.widgetId} {
    opacity: 1;
    visibility: visible;
  }

  /* An OPEN switch menu must never be hover-gated. Chrome drops :hover under a
     stationary pointer when React re-renders (which opening the menu causes),
     and the 0.2s visibility transition then turns the open dropdown into an
     invisible click-through ghost — the click falls through to the header
     underneath and puts the widget under edit instead of switching its type.
     (Second click works because entering edit re-renders and the user's mouse
     movement re-establishes :hover.) The shell stamps data-menu-open on the
     container while the ActionMenu is open (focus can't be used: the trigger
     doesn't retain it), so an open menu stays interactive regardless of hover. */
  #widget-switch-${props => props.widgetId}[data-menu-open="true"] {
    opacity: 1;
    visibility: visible;
  }

`;



export const ArrowWrapper = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: ${actionButtonSize}rem;
  height: ${actionButtonSize}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(${(props) => (props.isExpanded ? 180 : 0)}deg);
  ${transition("transform 0.1s ease-out")};
`;

export const StyledWidgetWrapper = styled.div`
  /* Remove padding when containing widget error state */
  &:has(.widget-error-state) {
    padding: 0;
  }

  ${({ isExpanded }) => 
    isExpanded 
      ? 
        css`
          height: max-content;
          overflow: unset;
          flex: 1;
          /* display: flex; */
        `
      : css`
          height: 0;
          overflow: hidden;
          flex: 0;
          /* display: block; */
      `
  }

  ${transition("all")}
  ${globalScrollbarStyling}

`

export const StyledDragHandle = styled.div`
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 5;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: ${colors2.white};
  border: 1px solid ${colors2.grey10};
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  transform-origin: top left;

  &:hover {
    transform: scale(1.5);
  }
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`


export const StyledTagsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const StyledTooltipBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 30rem;
  padding: 0.8rem;
`;

export const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-bottom: ${({ $isLast }) => ($isLast ? "0" : "0.8rem")};
  border-bottom: ${({ $isLast }) =>
    $isLast ? "none" : `0.1rem solid ${colors2.white}4d`};
`;

export const IconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  background-color: ${colors2.grey5};
  color: ${colors2.grey80};
  cursor: pointer;
  transition: all 0.15s ease;
  cursor: pointer;

  &:hover {
    background-color: ${colors2.secondaryContainer};
    color: ${colors2.onSecondary};
  }
`;